import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";

import InputSearch from "../../../components/InputSearch/InputSearch";
import Table from "../../table/Table";
import RankingIndicator from "./RankingIndicator/RankingIndicator";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { toast, ToastContainer } from "react-toastify";

import { ReactComponent as IconSearch } from "../../../build/images/icons/search02.svg";
import { ReactComponent as ExcelIcon } from "../../../build/images/nps-dashboard-icons/excel.svg";

import "./rankings.css";
import { format } from "date-fns";
import {
  getHealthInsuranceTableContent,
  getRankingEnviadasPlano,
  getRankingSended,
  getUnityTableContent,
} from "../../../services/nps/functions";
import NpsLoading from "../../NpsLoading";
import Paperplane from "../../Loading/Paperplane/Paperplane";

export default function Rankings() {
  //REDUX - Selectors
  const filtersDashboard = useSelector((state) => state.npsfilters);

  //STATES
  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [searchData, setSearchData] = useState("");
  const [tabActive, setTabActive] = useState("Unidades");
  const [filteredUnityData, setFilteredUnityData] = useState([]);
  const [unityRawData, setUnityRawData] = useState([]);
  const [filteredInsuranceData, setFilteredInsuranceData] = useState([]);
  const [insuranceRawData, setInsuranceRawData] = useState([]);
  const [loadingUnity, setLoadingUnity] = useState(false);
  const [loadingInsurance, setLoadingInsurance] = useState(false);
  const [unitError, setUnitError] = useState(false);
  const [insuranceError, seInsuranceError] = useState(false);
  const [idUnit, setIdUnit] = useState(getIdUnit());
  const [businessId, setBusinessId] = useState(getBusinessId());
  const [questionsNPSIds, setQuestionsNPSIds] = useState(getIdQuestionsNPS());
  const [questionsCSATIds, setQuestionsCSATIds] =
    useState(getIdQuestionsCSAT());
  const [channelsIds, setChannelsIds] = useState(getIdChannels());

  //FUNCTIONS
  function getBusinessId(isUpdate = false) {
    let id = "";
    const data = filtersDashboard.business;
    if (data && data.length) {
      const idsArr = data.map((info) => {
        return info.id;
      });
      if (idsArr && idsArr.length) {
        id = idsArr.join(",");
      }
    }
    if (isUpdate) {
      setBusinessId(id);
      return id;
    } else {
      return id;
    }
  }

  function getIdUnit(isUpdate = false) {
    let id = "";
    const data = filtersDashboard.units;
    if (data && data.length) {
      const idsArr = data.map((info) => {
        return info.id;
      });
      if (idsArr && idsArr.length) {
        id = idsArr.join(",");
      }
    }
    if (isUpdate) {
      setIdUnit(id);
      return id;
    } else {
      return id;
    }
  }

  function getIdQuestionsNPS(isUpdate = false) {
    let id = "";
    const data = filtersDashboard.questionsNPS;
    if (data && data.length) {
      const idsArr = data.map((info) => {
        return info.id;
      });
      if (idsArr && idsArr.length) {
        id = idsArr.join(",");
      }
    }
    if (isUpdate) {
      setQuestionsNPSIds(id);
      return id;
    } else {
      return id;
    }
  }

  function getIdQuestionsCSAT(isUpdate = false) {
    let id = "";
    const data = filtersDashboard.questionsCSAT;
    if (data && data.length) {
      const idsArr = data.map((info) => {
        return info.id;
      });
      if (idsArr && idsArr.length) {
        id = idsArr.join(",");
      }
    }
    if (isUpdate) {
      setQuestionsCSATIds(id);
      return id;
    } else {
      return id;
    }
  }

  function getIdChannels(isUpdate = false) {
    let id = "";
    const data = filtersDashboard.channels;
    if (data && data.length) {
      const idsArr = data.map((info) => {
        return info.id;
      });
      if (idsArr && idsArr.length) {
        id = idsArr.join(",");
      }
    }
    if (isUpdate) {
      setChannelsIds(id);
      return id;
    } else {
      return id;
    }
  }

  function defaultSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    }

    return 0;
  }

  /*
  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
  }
*/
  async function updateUnityTableContent(
    startDate,
    endDate,
    idUnit,
    businessId,
    questionsNPSIds,
    questionsCSATIds,
    channelsIds,
  ) {
    setLoadingUnity(true);
    const data = await getUnityTableContent(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );
    const responseTotalSended = await getRankingSended(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );
    const hasResponseTotalSended =
      !!responseTotalSended && responseTotalSended.status === 200;
    if (data === "ERROR" || !hasResponseTotalSended) {
      setUnitError(true);
      setUnityRawData([]);
      setLoadingUnity(false);
      return;
    } else {
      setUnitError(false);
    }

    const hasDataTotalSended =
      hasResponseTotalSended &&
      !!responseTotalSended.data &&
      Array.isArray(responseTotalSended.data) &&
      responseTotalSended.data.length > 0;
    if (data && data.length && hasResponseTotalSended) {
      const dataToRender = data.map((insuranceInfo, index) => {
        const dataOfTotalSended = responseTotalSended.data;
        const infosAboutTotalSendedOfThisUnity = dataOfTotalSended.find(
          (sendedInfoOfThisUnity) => {
            return (
              sendedInfoOfThisUnity.idunidade.toString() ===
              insuranceInfo.idunidade
            );
          },
        );
        const hasInfosAboutTotalSendedOfThisUnity =
          !!infosAboutTotalSendedOfThisUnity;
        let qtde_envio = hasInfosAboutTotalSendedOfThisUnity
          ? Number(infosAboutTotalSendedOfThisUnity.qtde_envio)
          : 0;

        const npsDenominator =
          insuranceInfo.detrator +
          insuranceInfo.neutro +
          insuranceInfo.promotor;

        const promoterQtd = insuranceInfo.promotor ? insuranceInfo.promotor : 0;
        const detractorQtd = insuranceInfo.detrator
          ? insuranceInfo.detrator
          : 0;
        const neutralQtd = insuranceInfo.neutro ? insuranceInfo.neutro : 0;
        const totalToCalcNps = promoterQtd + detractorQtd + neutralQtd;
        const calcNps = totalToCalcNps
          ? (((promoterQtd - detractorQtd) / totalToCalcNps) * 100).toFixed(2)
          : "0.00";
        /*
        const npsNote = npsDenominator
          ? (insuranceInfo.promotor / npsDenominator -
              insuranceInfo.detrator / npsDenominator) *
            100
          : "";
          */
        return {
          "#": {
            data: `${index + 1}`,
            config: {
              className: "",
            },
          },
          unity: {
            data: insuranceInfo.unidade,
            config: {
              className: "",
            },
          },
          ranking: {
            data: (
              <RankingIndicator
                promoterNumber={
                  insuranceInfo.promotor ? insuranceInfo.promotor : 0
                }
                detractorNumber={
                  insuranceInfo.detrator ? insuranceInfo.detrator : 0
                }
                neutralNumber={insuranceInfo.neutro ? insuranceInfo.neutro : 0}
              />
            ),
            config: {
              className: "",
            },
          },
          note: {
            data: calcNps === "" ? "" : `${calcNps} NPS`,
            config: {
              className: "",
            },
          },
          qtd: {
            data: insuranceInfo.qtde,
            config: {
              className: "",
            },
          },
          sended: {
            data: qtde_envio,
            config: {
              className: "",
            },
          },
          answered: {
            data: insuranceInfo.qtde_avaliada,
            config: {
              className: "",
            },
          },
          "%": {
            data: qtde_envio
              ? ((insuranceInfo.qtde_avaliada / qtde_envio) * 100).toFixed(0) +
                "%"
              : "",
            config: {
              className: "",
            },
          },
        };
      });

      setUnityRawData(dataToRender);
    } else {
      setUnityRawData([]);
    }
    setLoadingUnity(false);
  }

  async function updateInsuranceTableContent(
    startDate,
    endDate,
    idUnit,
    businessId,
    questionsNPSIds,
    questionsCSATIds,
    channelsIds,
  ) {
    setLoadingInsurance(true);
    const data = await getHealthInsuranceTableContent(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );

    const responseTotalSended = await getRankingEnviadasPlano(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );

    const hasResponseTotalSended =
      !!responseTotalSended && responseTotalSended.status === 200;

    if (data === "ERROR" || !hasResponseTotalSended) {
      seInsuranceError(true);
      setInsuranceRawData([]);
      setLoadingInsurance(false);
      return;
    } else {
      seInsuranceError(false);
    }

    const hasDataTotalSended =
      hasResponseTotalSended &&
      !!responseTotalSended.data &&
      Array.isArray(responseTotalSended.data) &&
      responseTotalSended.data.length > 0;

    if (data && data.length && hasResponseTotalSended) {
      const dataToRender = data.map((insuranceInfo, index) => {
        const dataOfTotalSended = responseTotalSended.data;
        const infosAboutTotalSendedOfThisInsurance = dataOfTotalSended.find(
          (sendedInfoOfThisInsurance) => {
            const hasIdPlano =
              sendedInfoOfThisInsurance.idplano !== undefined &&
              sendedInfoOfThisInsurance.idplano !== null;

            if (hasIdPlano) {
              return (
                sendedInfoOfThisInsurance.idplano.toString() ===
                insuranceInfo.idplano
              );
            }

            return false;
          },
        );
        const hasInfosAboutTotalSendedOfThisInsurance =
          !!infosAboutTotalSendedOfThisInsurance;
        let qtde_envio = hasInfosAboutTotalSendedOfThisInsurance
          ? Number(infosAboutTotalSendedOfThisInsurance.qtde_envio)
          : 0;
        /*
        const npsDenominator =
          insuranceInfo.detrator +
          insuranceInfo.neutro +
          insuranceInfo.promotor;
        const npsNote = npsDenominator
          ? (insuranceInfo.promotor / npsDenominator -
              insuranceInfo.detrator / npsDenominator) *
            100
          : "";
          */
        const promoterQtd = insuranceInfo.promotor ? insuranceInfo.promotor : 0;
        const detractorQtd = insuranceInfo.detrator
          ? insuranceInfo.detrator
          : 0;
        const neutralQtd = insuranceInfo.neutro ? insuranceInfo.neutro : 0;
        const totalToCalcNps = promoterQtd + detractorQtd + neutralQtd;
        const calcNps = totalToCalcNps
          ? (((promoterQtd - detractorQtd) / totalToCalcNps) * 100).toFixed(2)
          : "0.00";

        return {
          "#": {
            data: `${index + 1}`,
            config: {
              className: "",
            },
          },
          unity: {
            data: insuranceInfo.plano,
            config: {
              className: "",
            },
          },
          ranking: {
            data: (
              <RankingIndicator
                promoterNumber={
                  insuranceInfo.promotor ? insuranceInfo.promotor : 0
                }
                detractorNumber={
                  insuranceInfo.detrator ? insuranceInfo.detrator : 0
                }
                neutralNumber={insuranceInfo.neutro ? insuranceInfo.neutro : 0}
              />
            ),
            config: {
              className: "",
            },
          },
          note: {
            data: calcNps === "" ? "" : `${calcNps} NPS`,
            config: {
              className: "",
            },
          },
          qtd: {
            data: insuranceInfo.qtde,
            config: {
              className: "",
            },
          },
          sended: {
            data: qtde_envio,
            config: {
              className: "",
            },
          },
          answered: {
            data: insuranceInfo.qtde_avaliada,
            config: {
              className: "",
            },
          },
          "%": {
            data: qtde_envio
              ? ((insuranceInfo.qtde_avaliada / qtde_envio) * 100).toFixed(0) +
                "%"
              : "",
            config: {
              className: "",
            },
          },
        };
      });

      setInsuranceRawData(dataToRender);
    } else {
      setInsuranceRawData([]);
    }
    setLoadingInsurance(false);
  }

  function handleGenerateExcel() {
    const currentData =
      tabActive === "Unidades" ? filteredUnityData : filteredInsuranceData;

    if (!currentData || currentData.length === 0) {
      toast.warning("Não há dados para exportar no momento.");
      return;
    }

    const excelData = currentData.map((row) => {
      return {
        "#": row["#"] ? row["#"].data : "",
        [tabActive === "Unidades" ? "Unidade" : "Convênio"]: row.unity
          ? row.unity.data
          : "",
        Nota: row.note ? row.note.data : "",
        Enviadas: row.sended ? row.sended.data : 0,
        Respondidas: row.answered ? row.answered.data : 0,
        "Adesão (%)": row["%"] ? row["%"].data : "",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, tabActive);

    XLSX.writeFile(workbook, `Ranking_${tabActive}.xlsx`);
  }

  function filterDataWithSearch(searchData, rawData, type = "Unidades") {
    if (searchData && rawData && rawData.length) {
      const filteredData = rawData.filter((data) => {
        const unityComparation = data.unity.data
          ? data.unity.data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;
        const noteComparation = data.note.data
          ? data.note.data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;
        const qtdComparation =
          data.qtd.data || data.qtd.data === 0
            ? data.qtd.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const sendedComparation =
          !!data.sended.data || data.sended.data === 0
            ? data.sended.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const answeredComparation =
          !!data.answered.data || data.answered.data === 0
            ? data.answered.data
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())
            : false;
        const percentComparation = data["%"].data
          ? data["%"].data
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          : false;

        return (
          unityComparation ||
          noteComparation ||
          sendedComparation ||
          answeredComparation ||
          percentComparation
        );
      });
      if (type === "Unidades" || type === "unidades") {
        setFilteredUnityData(filteredData ? filteredData : []);
      } else {
        setFilteredInsuranceData(filteredData ? filteredData : []);
      }
    } else {
      if (type === "Unidades" || type === "unidades") {
        setFilteredUnityData(rawData);
      } else {
        setFilteredInsuranceData(rawData);
      }
    }
  }

  const columnsTable = [
    {
      Header: "#",
      accessor: "#",
      id: "#",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: tabActive === "Unidades" ? "Unidade" : "Convênios",
      accessor: "unity",
      id: "unity",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Ranking",
      accessor: "ranking",
      id: "ranking",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Nota",
      accessor: "note",
      id: "note",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Enviadas",
      accessor: "sended",
      id: "sended",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Respondidas",
      accessor: "answered",
      id: "answered",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
    {
      Header: "Adesão",
      accessor: "%",
      id: "%",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
    },
  ];

  //USE EFFECTS
  useEffect(() => {
    if (tabActive === "Unidades" && unitError) {
      toast.error(
        "Não foi possível fazer a sua consulta no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        },
      );
    }
    if (tabActive !== "Unidades" && insuranceError) {
      toast.error(
        "Não foi possível fazer a sua consulta no momento, tente novamente mais tarde!",
        {
          position: "top-center",
        },
      );
    }
  }, [insuranceError, unitError, tabActive, filtersDashboard]);
  useEffect(() => {
    if (filtersDashboard && filtersDashboard.datestart) {
      setInitialDate(filtersDashboard.datestart);
    }
    if (filtersDashboard && filtersDashboard.dateend) {
      setFinalDate(filtersDashboard.dateend);
    }
    if (filtersDashboard && filtersDashboard.units) {
      getIdUnit(true);
    }
    if (filtersDashboard && filtersDashboard.business) {
      getBusinessId(true);
    }
    if (filtersDashboard && filtersDashboard.questionsNPS) {
      getIdQuestionsNPS(true);
    }
    if (filtersDashboard && filtersDashboard.questionsCSAT) {
      getIdQuestionsCSAT(true);
    }
    if (filtersDashboard && filtersDashboard.channels) {
      getIdChannels(true);
    }
    if (filtersDashboard && filtersDashboard.business) {
      getBusinessId(true);
    }
  }, [filtersDashboard]);

  useEffect(() => {
    const startDate = format(new Date(initialDate), "yyyy-MM-dd");
    const endDate = format(new Date(finalDate), "yyyy-MM-dd");

    updateInsuranceTableContent(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );
    updateUnityTableContent(
      startDate,
      endDate,
      idUnit,
      businessId,
      questionsNPSIds,
      questionsCSATIds,
      channelsIds,
    );
  }, [
    initialDate,
    finalDate,
    idUnit,
    businessId,
    questionsNPSIds,
    questionsCSATIds,
    channelsIds,
  ]);

  useEffect(() => {
    setFilteredUnityData(unityRawData);
    setFilteredInsuranceData(insuranceRawData);
  }, [unityRawData, insuranceRawData]);

  useEffect(() => {
    if (!searchData) {
      setFilteredUnityData(unityRawData);
      setFilteredInsuranceData(insuranceRawData);
    }
  }, [searchData]);

  return (
    <div className="container-rankings-quality" role="main">
      <header className="container-header">
        <div className="content-header">
          <div className="cards-headers">
            <h4>Ranking</h4>
          </div>

          <div className="container-input">
            <InputSearch
              search={searchData}
              setSearch={setSearchData}
              icon={<IconSearch />}
              placeholder="Pesquisar"
              onSearch={() => {
                filterDataWithSearch(searchData, unityRawData);
                filterDataWithSearch(
                  searchData,
                  insuranceRawData,
                  "Insurances",
                );
              }}
              onKeyDown={true}
            />

            <div className="container-input__icon">
              <ExcelIcon
                onClick={handleGenerateExcel}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </header>

      <div className="ranking-table-container">
        <nav className="filter-and-caption" aria-label="Ranking Filters">
          <div className="filter-and-caption__tabs">
            <div className="table-groups">
              <button
                className={`button-tabs ${
                  tabActive === "Unidades" ? "active" : ""
                }`}
                onClick={() => setTabActive("Unidades")}
              >
                <div className="button-tabs__text">
                  <h2 className="button-tabs__text__h5">Unidades</h2>
                </div>
              </button>

              <button
                className={`button-tabs ${
                  tabActive === "Convênios" ? "active" : ""
                }`}
                onClick={() => setTabActive("Convênios")}
              >
                <div className="button-tabs__text">
                  <h2 className="button-tabs__text__h5">Convênios</h2>
                </div>
              </button>
            </div>

            <span className="division" />
          </div>

          <div className="rankings" aria-label="Ranking Legend">
            <div className="district-promoter">
              <span className="district-promoter__color" />
              <h3 className="district-promoter__h6">Promotor</h3>
            </div>

            <div className="neutral">
              <span className="neutral__color" />
              <h3 className="neutral__h6">Neutro</h3>
            </div>

            <div className="detractor">
              <span className="detractor__color" />
              <h3 className="detractor__h6">Detrator</h3>
            </div>
          </div>
        </nav>

        {tabActive === "Unidades" ? (
          <section
            className="container-ranking-table"
            aria-labelledby="ranking-table-heading"
          >
            {loadingUnity ? (
              <Paperplane />
            ) : filteredUnityData && filteredUnityData.length ? (
              <Table
                fixedHeader
                className="ranking-table"
                columns={columnsTable}
                data={filteredUnityData}
                classDivWrapperTable="ranking-table-wrapper-table"
                screen="npsTables"
              />
            ) : (
              <div className="container-ranking-table__empty">
                <EmptyState />
              </div>
            )}
          </section>
        ) : (
          <section
            className="container-ranking-table"
            aria-labelledby="ranking-table-heading"
          >
            {loadingInsurance ? (
              <Paperplane />
            ) : filteredInsuranceData && filteredInsuranceData.length ? (
              <Table
                fixedHeader
                className="ranking-table"
                columns={columnsTable}
                data={filteredInsuranceData}
                classDivWrapperTable="ranking-table-wrapper-table"
                screen="npsTables"
              />
            ) : (
              <div className="container-ranking-table__empty">
                <EmptyState />
              </div>
            )}
          </section>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}
